export default __webpack_public_path__ + "static/media/przysmak_deskto.48dbd1d9.webp";